import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CourseService } from '@app/_services/course.service';
import { first } from 'rxjs/operators';
import { DashboardService } from '../../_services/dashboard.service';

@Component({ selector: 'journey', templateUrl: 'journey.component.html' })
export class JourneyComponent {
    @Input() sectionId: any;
    sectionType: any;
    courseId: any;



    constructor(private router: Router, private dashboardService: DashboardService, private courseService: CourseService) { }
    courses: any = [];
    allCoursesCompleted: boolean;

    northnearstarscourse: any = [];
    dataId: any;
    datarespond: any;
    botonshow:any;
    botonhidden: any;
    typesection:any;


    ngOnInit() {

        this.allCoursesCompleted = true;

        this.dashboardService.getDashboardJourney().pipe(first()).subscribe(data => {

            data.map(x => {
                let course = x;

                if (course.finished) {
                    course.percentage = 100;
                }
                else {
                    course.percentage = x.currentSection * 100 / x.totalSections;
                }


                this.allCoursesCompleted = this.allCoursesCompleted && course.finished;

                //North and Near star
                this.dataId = x.courseId == 1;
                 this.datarespond= (this.dataId && !course.finished) ? 'light-theme': 'white-theme';
                 this.botonshow= (this.dataId && course.finished) ? 'disable': '';
                 this.botonhidden= (this.dataId && course.finished) ? '': 'disable';
                //

                course.expandedShow = (course.available && !course.finished) ? 'show' : '';
                course.collapsedShow = (!course.available || course.finished) ? 'show' : '';

                this.courses.push(course);
            });

        });

         //North and Near star

         this.dashboardService.getnorthnearstarscourse().pipe(first()).subscribe(data => {

            data.map(x => {
                let Info = x;

                 Info.expandedShow = (Info.available) ? 'show' : '';
                Info.collapsedShow =  (!Info.available) ? 'show' : '';

                  this.northnearstarscourse.push(Info);
            });

        });
    }

    continueToSection(course) {
        return !course.hasPrecourse || (course.hasPrecourse && course.userHasPrecourseEvent);
    }

    continueToPreCourse(course) {
        return course.hasPrecourse && !course.userHasPrecourseEvent;
    }

    getIntro(courseId) {
        this.courseService.getIntroId(courseId).subscribe(data => {   
            this.router.navigate(['/course-section', data.introSectionId]) 
        });
    }

}